export var WithdrawPointReason;
(function (WithdrawPointReason) {
    WithdrawPointReason["DEPOSIT"] = "deposit";
    WithdrawPointReason["WITHDRAW"] = "withdraw";
    WithdrawPointReason["ACTIVITY"] = "activity";
    WithdrawPointReason["POINT"] = "point";
    WithdrawPointReason["ADMIN"] = "admin";
    WithdrawPointReason["FEEDBACK"] = "feedback";
    WithdrawPointReason["OTHERS"] = "others";
    WithdrawPointReason["RC_ADJUSTMENT"] = "rc_adjustment";
    WithdrawPointReason["RESET"] = "reset";
})(WithdrawPointReason || (WithdrawPointReason = {}));
//# sourceMappingURL=WithdrawPointReason.js.map